import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M3.46967 3.46967C3.76256 3.17678 4.23744 3.17678 4.53033 3.46967L8 6.93934L11.4697 3.46967C11.7626 3.17678 12.2374 3.17678 12.5303 3.46967C12.8232 3.76256 12.8232 4.23744 12.5303 4.53033L9.06066 8L12.5303 11.4697C12.8232 11.7626 12.8232 12.2374 12.5303 12.5303C12.2374 12.8232 11.7626 12.8232 11.4697 12.5303L8 9.06066L4.53033 12.5303C4.23744 12.8232 3.76256 12.8232 3.46967 12.5303C3.17678 12.2374 3.17678 11.7626 3.46967 11.4697L6.93934 8L3.46967 4.53033C3.17678 4.23744 3.17678 3.76256 3.46967 3.46967Z';
const draw24px =
  'M18.53,17.47a.75.75,0,0,1,0,1.06.75.75,0,0,1-1.06,0L12,13.06,6.53,18.53a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06L10.94,12,5.47,6.53A.75.75,0,0,1,6.53,5.47L12,10.94l5.47-5.47a.75.75,0,0,1,1.06,1.06L13.06,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const XIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'x'),
) as IconWithRender;

XIcon.displayName = 'XIcon';
XIcon.propTypes = Icon.propTypes;
XIcon.renderIcon = (props) => <XIcon {...props} />;
export default XIcon;
